export default [{
  header: 'Gestión Documentos',
  icon: 'PackageIcon',
  i18n: 'Documentos',
  items: [
    {
      url: { name: 'document-management' },
      name: 'Gestión Documental',
      icon: 'FolderIcon',
      permiso: '*'
    },
  ]
}];
